import React from 'react';
import clsx from 'clsx';
import TooltipTextSC from './styles/TooltipTextSC';
import factoryTooltip from './utils/factoryTooltip';
const TooltipText = (props) => {
    const { title, forwardedRef, rootStyle, placement, arrowProps, className: classNameProp } = props;
    return (React.createElement(TooltipTextSC, { ref: forwardedRef, style: rootStyle, "data-placement": placement, className: clsx('_ndsTooltip', classNameProp) },
        React.createElement("div", { className: "_ndsTooltip__content" }, title),
        React.createElement("div", { ref: arrowProps.ref, style: arrowProps.style, className: "_ndsTooltip__arrow" })));
};
export default factoryTooltip(TooltipText, 'text');
//# sourceMappingURL=TooltipText.js.map